<template>
    <section class="container-fluid">
        <div class="row mcas">
            <div class="col-md-6 col-lg-4 main">
                <div class="row" id="odrea">
                    <div class="col-12 m-record">
                        <div class="row nav-top auto">
                            <div class="col-2 xtl"><span class="nav-back wt"
                                    onclick="window.location.href='#/promotion'"></span></div>
                            <div class="col-8 tfw-5 tf-18">Invite Record</div>
                            <div class="col-2"></div>
                        </div>
                        <div class="row">
                            <div class="col-12 tfcdb odtnav">
                                <div class="xtl tfw-6 tf-16 pt-2 pb-2">The total number of invites is <span
                                        class="tfs-org" id="tnoinv">{{ this.invite.people }}</span></div>
                                <div class="xtc tf-14">
                                    <div class="invnav">
                                        <div class="inavlist act"></div>
                                        <div class="inavlist act">Lv1</div>
                                        <div class="inavlist act">Lv2</div>
                                        <div class="inavlist act">Lv3</div>
                                    </div>
                                    <div class="invnav">
                                        <div class="inavlist">Number</div>
                                        <div class="inavlist" id="nlv1">{{ this.invite.level1 }}</div>
                                        <div class="inavlist" id="nlv2">{{ this.invite.level2 }}</div>
                                        <div class="inavlist" id="nlv3">{{ this.invite.level3 }}</div>
                                    </div>
                                </div>
                                <div class="tf-12 pt-2 pb-2">*Real Time Statistics.</div>
                            </div>
                            <div class="col-12 pa-0 pt-2 pb-2 odtnav"><select class="odselect bgbp tfs-w"
                                    @change="invtab()" v-model="userdetails.level" id="invtab">
                                    <option value="A">All</option>
                                    <option value="B">Level1</option>
                                    <option value="C">Level2</option>
                                    <option value="D">Level3</option>
                                </select></div>
                            <div class="col-12 tf-14">
                                <div class="row">
                                    <div class="col-4 xtl">User</div>
                                    <div class="col-4">Level</div>
                                    <div class="col-4 xtr">Registration</div>
                                </div>
                            </div>
                        </div>
                        <div class="row mr-0">
                            <div class="col-12 pa-0" id="dtaod">
                                <div class="row pt-1 pb-1"   v-for="row in inviterecord" :key="row.id">
                                    <div class="col-4 xtl">{{row.usercode}}</div>
                                    <div class="col-4">Level {{ row.level }}</div>
                                    <div class="col-4 xtr">{{ settime(row.created_at)}}</div>
                                </div>

                                <div id="norecord" class="mt-4 pt-4 tfcdg" style="display: none;">
                                    <div class="pt-3 tf-14">No records</div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row" id="opffp"></div>
                <div class="row" id="anof">
                </div>
                <div class="row" id="dta_ref"></div>
            </div>
        </div>
    </section>
</template>
<script>
import axios from "axios";
export default {
    name: "PromotionView",
    data() {
        return {
            userdetails: {
                level: 'A',
            },
            inviterecord: {

            },
            invite: {

            },
            info: {

            }

        }

    },
    mounted: function prepare() {
        this.getrecord();
    },
    methods: {
        settime(time){
            var datetime = new Date(time);
            datetime.setHours(datetime.getHours() + 12)
        datetime.setMinutes(datetime.getMinutes() + 30)
        var time1= datetime.toLocaleString();
        var timeStamp=Date.parse(time1);
        const date= new Date(timeStamp);
        var dateFormat =  date.getDate()+
           "-"+(date.getMonth()+1)+"-"+date.getFullYear();
        return dateFormat;
        },
        invtab() {
            console.log(this.userdetails.level);
            this.getrecord();
        },
        getrecord() {
            this.userdetails.username = localStorage.getItem('username');

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/me.php?action=getuserinfo&user=' + this.userdetails.username).then((res) => {
                this.info = res.data.user_Data[0];
                console.log(this.info);

            }).catch((err) => {
                console.log(err);
            })

            axios.get('https://fiewin.source-code.co.in/Gameapi/src/api/bet.php?action=inviterecord&user=' + this.userdetails.username + '&level=' + this.userdetails.level).then((res) => {
                this.inviterecord = res.data[0];
                this.invite = res.data[1][0];
                console.log(this.inviterecord);
                console.log(this.invite);
                if (this.inviterecord.length ==0) {
                    document.getElementById("norecord").style.display = "";
                }else{
                    document.getElementById("norecord").style.display = "none";
                }
            }).catch((err) => {
                console.log(err);
            })
        },
    }
}

</script>